export default ({ request }) => ({
  orderReviewPendingListApi(data = {}) {
    return request({
      url: '/factory/orderReview/pendingList',
      method: 'post',
      data
    })
  },
  orderReviewListApi(data = {}) {
    return request({
      url: '/factory/orderReview/list',
      method: 'post',
      data
    })
  },
  orderReviewSaveApi(data = {}) {
    return request({
      url: '/factory/orderReview/save',
      method: 'post',
      data
    })
  },
  orderReviewDetailApi(data = {}) {
    return request({
      url: '/factory/orderReview/detail',
      method: 'post',
      data
    })
  },
  orderReviewDelApi(data = {}) {
    return request({
      url: '/factory/orderReview/del',
      method: 'post',
      data
    })
  },
  orderExportCheckDataApi(data = {}) {
    return request({
      url: '/factory/orderReview/checkData',
      method: 'post',
      data
    })
  }
})
